import { render, staticRenderFns } from "./ComprovantesPrint.vue?vue&type=template&id=d101d4c2"
import script from "./ComprovantesPrint.vue?vue&type=script&lang=ts"
export * from "./ComprovantesPrint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports